import { ColorIcon, colors, customEvent, HStack, VStack } from "goi_common";
import React, { ReactNode } from "react";

export default function CareRegionCard({
  id,
  companyname,
  address,
  doc_fulltime,
  total_people,
}: {
  id: number;
  companyname: string;
  address: string;
  doc_fulltime: number;
  total_people: number;
}) {
  return (
    <a
      target="_self"
      href={`/care/${id}/`}
      onClick={() => {
        customEvent({
          newGtm: { path: "care", trigger_and_target: "card-uv_detail" },
        });
      }}
    >
      <VStack
        padding="12px 16px"
        borderRadius="10px"
        css={{ boxShadow: "0px 0px 7px 0px rgba(113, 120, 125, 0.20)" }}
        gap="10px"
      >
        <h3 className="subtitle_18_b gray900">{companyname}</h3>
        <p className="body_14_m gray600">{address}</p>
        <HStack gap="8px">
          <CardTag
            text={`입소 정원 ${total_people || 0}명`}
            iconName="people"
          />
          <CardTag
            text={`전임 의사 수 ${doc_fulltime || 0}명`}
            iconName="cross"
          />
        </HStack>
        <HStack
          className="orange650 subtitle_14_b"
          alignItems="center"
          justifyContent="flex-end"
          margin="6px 0 0"
          gap="3px"
        >
          확인하기
          <ColorIcon
            name="arrow_right_small"
            size={16}
            color={colors.orange650}
          />
        </HStack>
      </VStack>
    </a>
  );
}

function CardTag({
  text,
  iconName,
}: {
  text: ReactNode;
  iconName: "cross" | "people";
}) {
  return (
    <HStack
      css={{
        padding: "6px 10px",
        color: colors.warmGray700,
        background: colors.warmGray100,
        borderRadius: "30px",
      }}
      className="caption_12_m"
      gap="5px"
    >
      <ColorIcon name={iconName} size={16} color={colors.warmGray700} />
      <p>{text}</p>
    </HStack>
  );
}
